import { ReactElement, cloneElement } from 'react'
import classNames from 'classnames'

import { Alignment, Position, Size } from '../types'

import styles from './app-group.module.scss'

export type AppGroupProps = {
  children: ReactElement[]
  alignment?: Alignment
  position?: Position
  fullWidth?: boolean | 'mobile'
  size?: Size
  gapSize?: Size
}

const AppGroup = (props: AppGroupProps) => {
  const {
    children,
    alignment = 'horizontal',
    position = 'left',
    fullWidth = false,
    size,
    gapSize = 'xsmall',
  } = props

  return (
    <div
      className={classNames(
        styles.appGroup,
        styles[alignment],
        styles[gapSize],
        fullWidth
          ? fullWidth === 'mobile'
            ? styles.fullWidthMobile
            : styles.fullWidth
          : undefined,
        styles[position]
      )}
    >
      {children.map((child, i) => {
        const props = { position, fullWidth } as Pick<
          AppGroupProps,
          'position' | 'fullWidth' | 'size'
        >
        if (size) props.size = size
        return child ? <div key={i}>{cloneElement(child, props)}</div> : null
      })}
    </div>
  )
}

export default AppGroup
